// import { useState, useEffect } from "react";
// import moment from "moment";

// const calculateTimeLeft = (leftDate) => {
//   let year = new Date().getFullYear();
//   let month = new Date().getMonth();
//   let difference = +new Date(`${leftDate}`) - +new Date();
//   let timeLeft = {
//     days: 0,
//     hours: 0,
//     minutes: 0,
//     seconds: 0,
//   };

//   if (difference > 0) {
//     timeLeft = {
//       days: Math.floor(difference / (1000 * 60 * 60 * 24)),
//       hours: Math.floor((difference / (1000 * 60 * 60)) % 24),
//       minutes: Math.floor((difference / 1000 / 60) % 60),
//       seconds: Math.floor((difference / 1000) % 60),
//     };
//   }

//   return timeLeft;
// };

// const useCountDownTime = (leftDate) => {
//   const [timeLeft, setTimeLeft] = useState(calculateTimeLeft(leftDate));

//   useEffect(() => {
//     const timer = setTimeout(() => {
//       setTimeLeft(calculateTimeLeft(leftDate));
//     }, 1000);
//     return () => clearTimeout(timer);
//   });

//   return timeLeft;
// };

// export default useCountDownTime;

import { useState, useEffect } from "react";
import moment from "moment";

const calculateTimeLeft = (leftDate) => {
  let endTime = moment(leftDate);
  const nowTime = moment();

  let timeLeft = {
    days: 0,
    hours: 0,
    minutes: 0,
    seconds: 0,
  };
  const duration = moment.duration(endTime.diff(nowTime));

  timeLeft = {
    days: duration.days(),
    hours: duration.hours(),
    minutes: duration.minutes(),
    seconds: duration.seconds(),
  };

  return timeLeft;
};

const useCountDownTime = (leftDate) => {
  const [timeLeft, setTimeLeft] = useState(calculateTimeLeft(leftDate));

  useEffect(() => {
    const timer = setTimeout(() => {
      setTimeLeft(calculateTimeLeft(leftDate));
    }, 1000);
    return () => clearTimeout(timer);
  });

  return timeLeft;
};

export default useCountDownTime;
